import { Link, useLocation } from 'react-router-dom';
import { Breadcrumbs as MantineBreadcrumbs } from '@mantine/core';
import { HomeIcon } from "@heroicons/react/outline";

const Breadcrumbs = () => {
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter((x) => x);
  // Function to determine if a segment is an ID
  const isId = (segment) => {
    // Adjust this condition based on how IDs are structured
    return /^\d+$/.test(segment);
  };

  // Filter out IDs from pathnames
  const filteredPathnames = pathnames.filter((segment) => !isId(segment));

  return (
    <MantineBreadcrumbs
      className="text-sm"
      separator={<span className=" text-gray-500">{'>'}</span>}
    >
      <Link to="/" className="flex items-center">
        <HomeIcon className="w-4 h-4 mr-1" />
        Home
      </Link>

      {filteredPathnames.map((value, index) => {
        const to = `/${filteredPathnames.slice(0, index + 1).join('/')}`;
        const isLastItem = index === filteredPathnames.length - 1;
        
        return isLastItem ? (
          <span key={to} className="text-gray-600">
            {value.charAt(0).toUpperCase() + value.slice(1)}
          </span>
        ) : (
          <Link key={to} to={to} className="text-blue-600 hover:text-red-500">
            {value.charAt(0).toUpperCase() + value.slice(1)}
          </Link>
        );
      })}
    </MantineBreadcrumbs>
  );
};

export default Breadcrumbs;
